import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { ApiGatewayField } from './CreateApiGatewayExtension';

export const CreateApiGatewayFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ApiGatewayField',
    component: ApiGatewayField,
  }),
);
